import { render } from "./CookiesLoading.vue?vue&type=template&id=4ccefb91&scoped=true"
import script from "./CookiesLoading.vue?vue&type=script&lang=js"
export * from "./CookiesLoading.vue?vue&type=script&lang=js"

import "./CookiesLoading.vue?vue&type=style&index=0&id=4ccefb91&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccefb91"]])

export default __exports__